import Bengaluru from "./images/location/b.png";
import Gurugram from "./images/location/g.png";
import Mumbai from "./images/location/m.png"
import Pune from "./images/location/p.png";
import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Our Presence ",
  locationtag: "",
  location: [
    {
      title: "Gurugram",
      propertcount: 8,
      image: Gurugram,
      link: `/location/gurugram`,
    },
    {
      title: "Bengaluru",
      propertcount: 1,
      image: Bengaluru,
      link: `/location/bengaluru`,
    },
    {
      title: "Pune",
      propertcount: 10,
      image: Pune,
      link: `/location/pune`,
    },
    {
      title: "Mumbai",
      propertcount: 5,
      image: Mumbai,
      link: `/location/mumbai`,
    },
  ],
};